import { Module } from 'vuex';
import { WaitingApplicationState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: WaitingApplicationState = {
    waitingApplications: undefined,
    waitingApplicationCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const waitingApplication: Module<WaitingApplicationState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
